/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";

export const KillswitchStatus = {
  Active: "active",
  Scheduled: "scheduled",
  Expired: "expired",
  Lifted: "lifted",
} as const;
export type KillswitchStatus = OpenEnum<typeof KillswitchStatus>;

/** @internal */
export const KillswitchStatus$inboundSchema: z.ZodMiniType<
  KillswitchStatus,
  unknown
> = openEnums.inboundSchema(KillswitchStatus);
